<template>
	<modal :withOkBtn="true" :withCancelBtn="true" :showSpinner="showSpinner" @close="$emit('close')" @ok="uploadFiles">
		<div slot="header">Upload your files</div>
		<div slot="body">
			<div class="form-group">
				<input type="file" ref="file" class="form-input" placeholder="Upload Files" accept="image/*" @change="onSelect">
			</div>
			<img id="newImage" :src="imageUrl" width="50%" :class="{'hide-image': isImageUrlEmpty}">
		</div>
	</modal>
</template>

<script>
	import Modal from './Modal'
	import axios from 'axios';
	import firebase from 'firebase';

	export default {
		name: 'UploadFilesModal',
		components: {
			'modal': Modal
		},
		data() {
			return {
				file: '',
				imageUrl: '',
				showSpinner: false
			}
		},
		computed: {
			isImageUrlEmpty() {
				return this.imageUrl === '';
			}
		},
		methods: {
			onSelect() {
				const file = this.$refs.file.files[0];
				this.file = file;
			},
			uploadFiles() {
				console.log('uploadFiles');
				let file = this.file;
				let fileName = file.name;
				console.log(fileName);

				this.showSpinner = true;
				// Create a root reference
				var storageRef = firebase.storage().ref();
				// Create a reference to 'images/filename'
				var newImageRef = storageRef.child('images/'+fileName);

				newImageRef.put(file).then(function(snapshot) {
					console.log('Uploaded a blob or file!');
					this.$emit('close');
				}.bind(this));
			}
		}
	}
</script>

<style scoped lang="scss">
	.form-input {
		height: unset;
	}

	.hide-image {
		display: none;
	}
</style>